import { Chip } from '@mui/material';
import { memo } from 'react';

type Props = {
  value: string;
};

const TransactionsSaleType = ({ value }: Props) => {
  return (
    <Chip
      color={value === 'buy' ? 'success' : 'error'}
      sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
      size="small"
      label={value}
    />
  );
};

export default memo(TransactionsSaleType);
